import React from "react";
import "./Certificate.css";

function Certificate() {
  return (
    <div>
      <main>
        <div className="m-1 border border-dark p-2">
          <section>
            <header className="flex flex-col items-center justify-center">
              <p className="heading">Original</p>
              <h6 className="topheader">FORM V</h6>
              <p className="top">Prescribed by the Government of India under</p>
              <h6 className="top">
                DOCK WORKERS (SAFETY,HEALTH AND WELFARE) REGULATIONS, 1990
              </h6>
              <p className="top">(See Regulations 47(1) and 51(2))</p>
              <p className="top">
                Certificate of Initial & Periodical Test & Examination of Loose
                Gear
              </p>
            </header>
          </section>

          <section>
            <div className="mainbox1">
              <div className="boxes1">
                <p className="heading">Test Certificate No:</p>
                <p className="heading">(a) In case of Dock, wharf of Quay</p>
                <p className="rightside">Name of dock, wharf of Quay</p>
                <p className="rightside">where Lifting</p>
                <p className="rightside">Appliances are fitted :</p>
              </div>
              <div className="boxes2">
                <p className="heading">(b) In case of Ship -</p>
                <p className="leftside">Name of the Ship :</p>
                <p className="leftside">Official Number :</p>
                <p className="leftside">Call Sign :</p>
                <p className="leftside">Port of Registry :</p>
                <p className="leftside">Name of Owner :</p>
              </div>
            </div>
          </section>

          <section>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th className="heading" scope="col">
                    Distinguishing Number or mark
                  </th>
                  <th className="heading" scope="col">
                    Description Dimension and material of gear/device
                  </th>
                  <th className="heading" scope="col">
                    Number tested
                  </th>
                  <th className="heading" scope="col">
                    Date of test
                  </th>
                  <th className="heading" scope="col">
                    Test load applied
                  </th>
                  <th className="heading" scope="col">
                    Safe working load (SWL)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr font-size="1px" height="5px">
                  <td height="5px"></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="heading" font-size="1px">
                    (Tonnes)
                  </td>
                  <td className="heading">(Tonnes)</td>
                </tr>
                <tr></tr>
                <tr>
                  <td height="300px"></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </section>

          <section>
            <div>
              <p className="heading">
                7.Name and address of manufacturer or supplier :
              </p>
            </div>
            <div>
              <p className="heading">
                8.Initial test and examination certificate no. and date :
              </p>
              <p className="rightside">
                (only in case of periodical test and examination)
              </p>
            </div>
            <div>
              <p className="heading">
                9.Name and address of public service, association, :
              </p>
              <p className="rightside">
                company or firm or testing establishment making
              </p>
              <p className="rightside">the test and examination</p>
            </div>
            <div>
              <p className="heading">
                10.Name and position of the Competent person in :
              </p>
              <p className="rightside">
                public service, association, company or firm or
              </p>
              <p className="rightside">testing establishment.</p>
            </div>
          </section>

          <section>
            <div>
              <p className="heading">
                I certify that on the 16th day of June 2012, the above gear was
                tested and examined in the manner set forth overleaf;
              </p>
              <p className="rightside">
                that the examination showed the said gear/device withstood the
                test load without injury or deformation; and that the safe
                working load
              </p>
              <p className="rightside">
                of the said gear/device as shown in column 6.
              </p>
            </div>
          </section>

          <section>
            <div>
              <p className="downheading">Signature of the Competent person</p>
              <p className="rightside">(See Note 2)</p>
            </div>
          </section>

          <section>
            <div className="mainbox1">
              <div className="boxes6">
                <p className="heading">
                  Registration / Authority number of the Competent Person
                </p>
              </div>
              <div className="boxes7">
                <p className="heading">Seal</p>
              </div>
              <div className="boxes8">
                <p className="heading">Date:</p>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}

export default Certificate;
